import '../css/landing.css';
import { useState } from 'react';
import member1 from '../assets/member1.jpg';
import member2 from '../assets/member2.jpg';
import member3 from '../assets/member3.jpg';
import member4 from '../assets/member4.jpg';

export default function MembersList() {
    // Sample members data (with images)
    const members = [
        { id: 1, name: 'ምህረት', role: 'አብይ ኮሚቴው', image: member1 },
        { id: 2, name: 'አምሃ', role: 'ሰብሳቢ', image: member2 },
        { id: 3, name: 'ኃይማኖት', role: 'ም/ሰብሳቢ', image: member3 },
        { id: 4, name: 'ገብረ መስቀል', role: 'ፀሐፊ', image: member4 },
    ];

    // Additional Amharic names
    const additionalNames = [
        'ማሪቱ', 'አበበ', 'ዮሴፍ', 'ደረጀ', 'አስፋ', 'ሀይሉ',
        'ጌታቸው', 'ዘለቀ', 'አዲስ', 'ተስፋዬ', 'ብሩክ', 'ዋሲሁ'
    ];

    // Amharic Fidel root letters in order
    const fidelOrder = [
        'ሀ', 'ለ', 'ሐ', 'መ', 'ሠ', 'ረ', 'ሰ', 'ሸ', 'ቀ', 'በ', 'ተ', 'ቸ', 
        'ኀ', 'ነ', 'ኘ', 'አ', 'ከ', 'ኸ', 'ወ', 'ዐ', 'ዘ', 'ዠ', 'የ', 'ደ', 
        'ጀ', 'ገ', 'ጠ', 'ጨ', 'ጰ', 'ፀ', 'ፈ', 'ፐ'
    ];

    // Function to get root letter (ignoring vowel variations)
    const getRootLetter = (name) => {
        const firstLetter = name[0]; 
        for (let root of fidelOrder) {
            if (firstLetter >= root && firstLetter <= String.fromCharCode(root.charCodeAt(0) + 6)) {
                return root;
            }
        }
        return firstLetter; // Fallback
    };

    // Group names by root letter
    const groupedNames = additionalNames.reduce((acc, name) => {
        const root = getRootLetter(name);
        if (!acc[root]) acc[root] = [];
        acc[root].push(name);
        return acc;
    }, {});

    // Sort groups by Amharic Fidel order
    const sortedGroups = Object.keys(groupedNames).sort(
        (a, b) => fidelOrder.indexOf(a) - fidelOrder.indexOf(b)
    );

    return (
        <div className="members-container">
            <h2 className="members-title">አባላት በማህበሩ</h2>
            <div className="members-list">
                {members.map((member) => (
                    <div key={member.id} className="member-card">
                        <img src={member.image} alt={member.name} className="member-image" />
                        <div className="member-info">
                            <h4 className="member-name">{member.name}</h4>
                            <p className="member-role">{member.role}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Alphabetically grouped names below images */}
            <div className="names-container">
                <h2 className="names-title">አባላት በፊደላት</h2>
                {sortedGroups.map((letter) => (
                    <div key={letter} className="name-group">
                        <h3 className="group-title">{letter}</h3>
                        <ul className="name-list">
                            {groupedNames[letter].map((name, index) => (
                                <li key={index} className="name-item">{name}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}
